import { useMutation } from '@tanstack/react-query';

import { useApiSDK } from '../../contexts/apiSdkContext';

type TLogin = {
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  mutate: (accessToken: string) => void;
};

function useLogout(): TLogin {
  const sdk = useApiSDK();

  const { isError, isLoading, isSuccess, mutate } = useMutation({
    mutationFn: async (accessToken: string) => {
      await sdk.auth.logout(accessToken);
    },
  });

  return { isError, isLoading, isSuccess, mutate };
}

export { useLogout };
